// @ts-ignore
import useSettings from './useSettings'

// @ts-ignore
import useAxios from "./useAxios";
import { useQuery } from "@tanstack/react-query";

const useModes = () => {
    const { settings } = useSettings();
    const { callApi } = useAxios();

    const { data: modes } = useQuery({
        enabled: !!settings?.token,
        queryKey: ['Mode', settings?.token],

        queryFn: async () => {
            if (!settings?.token) return;
            try {
                const modes = await callApi('get', '/user/modes');

                return modes;
            } catch (error) {
                console.error('Error fetching user data:', error);
                return null;
            }
        },
        staleTime: 1000 * 60 * 5,
    });

    return {
        modes,
    };
};

export default useModes;
